// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__15Kw2","buttons":"SendReceipts_buttons__oTEmK","email":"SendReceipts_email__3LFn7","bookApptTitle":"SendReceipts_bookApptTitle__3usIf"};